<template>
    <v-btn prepend-icon="mdi-connection"
           @click="loadDetails"
           variant="flat"
           class="mr-1"
           :loading="loading"
           color="grey-lighten-2">
        Load Nimp
    </v-btn>
</template>
<style scoped>

</style>
<script>
    function initialState() {
        return {
            loading: false
        };
    }
    import { mapActions } from "vuex";
    export default {
        name: "LoadNuwall",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            job: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "reloadEntities"
            ]),
            loadDetails() {
                this.$confirm(
                    {
                        message: 'This will load details from Nu-Wall?',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.loading = true;
                                this.$api.get('/jobs/loadnimp/?id=' + this.job.id)
                                    .then(res => {
                                        this.loading = false;
                                        this.loadEntityRecord({ entityId: this.job.id, entity: this.$constants.entities.Job });
                                    }).catch(error => {
                                        this.showErrorSnack('We ran into an issue');
                                        this.loading = false;
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
        }
    };
</script>